import { bool, func } from 'prop-types'
import Button from '../../Button/unwrapped'
import Conditional from '../../Conditional'
import { kuiperClassNames } from '../../utils'

import './styles.scss'

const Footer = ({ canClear, canSelectAll, clearAll, selectAll }) => (
  <div className={kuiperClassNames('menu-footer n10')}>
    <Button
      disabled={!canClear}
      label="Clear"
      size="small"
      onClick={clearAll}
      type="secondary"
    />
    <Conditional condition={canSelectAll}>
      <Button
        disabled={!canSelectAll}
        label="Select all"
        size="small"
        onClick={selectAll}
        type="secondary"
      />
    </Conditional>
  </div>
)

Footer.propTypes = {
  canClear: bool,
  canSelectAll: bool,
  clearAll: func,
  selectAll: func,
}

export default Footer
